import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from './locales/fr.json';
import en from './locales/en.json';
import it from './locales/it.json';
import tr from './locales/tr.json';
import ar from './locales/ar.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  it: { translation: it },
  tr: { translation: tr },
  ar: { translation: ar },
};

const saved = (typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : null) || 'en';
const initialLng = saved.slice(0, 2);

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    debug: false,
    keySeparator: '.',
    nsSeparator: ':',
  });

export default i18n;